import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch all store locator
export const fetchStoreLocator = createAsyncThunk(
  'store-locator/all',
  async (_, { rejectWithValue }) => {
    try {
      const url = `/api/store-locators`;
      const response = await axiosClient.get(url);

      return response?.data?.data;
    } catch (error) {
      console.error('Error fetching store locators:', error);
      return rejectWithValue(error.message);
    }
  },
);

// Async thunk to fetch nearby stores
export const fetchNearbyStores = createAsyncThunk(
  'nearbyStoreLocator',
  async ({ shippingAddressId }, { rejectWithValue }) => {
    try {
      const url = `/api/nearby-stores`;
      const response = await axiosClient.post(url, {
        shipping_address_id: shippingAddressId,
      });

      return response?.data?.data;
    } catch (error) {
      console.error('Error fetching nearby store locators:', error);
      return rejectWithValue(error.message);
    }
  },
);

// Async thunk to fetch specific store locator
export const fetchSpecificStoreLocator = createAsyncThunk(
  'store-locator/store-details',
  async ({ store_code }, { rejectWithValue }) => {
    try {
      const url = `/api/store-locator/store-details/${store_code}`;
      const response = await axiosClient.get(url);

      return response?.data?.data;
    } catch (error) {
      console.error('Error fetching specific store locators:', error);
      return rejectWithValue(error.message);
    }
  },
);

// Async thunk to fetch product store locator
export const fetchStoreLocatorProduct = createAsyncThunk(
  'store-locator/product',
  async ({ slug }, { rejectWithValue }) => {
    try {
      const url = `/api/store-locator/stores-with-product/${slug}`;
      const response = await axiosClient.get(url);
      return response?.data?.data;
    } catch (error) {
      console.error('Error fetching specific store locators:', error);
      return rejectWithValue(error.message);
    }
  },
);

// Async thunk to fetch specific product specific store locator
export const fetchSpecificStoreLocatorProduct = createAsyncThunk(
  'store-locator/product/selected-store',
  async ({ store_code, slug }, { rejectWithValue }) => {
    try {
      const url = `/api/store-locator/${store_code}/${slug}`;
      const response = await axiosClient.get(url);
      return response?.data?.data;
    } catch (error) {
      console.error('Error fetching specific store locators:', error);
      return rejectWithValue(error.message);
    }
  },
);
